import React from "react";
import { useNavigate } from "react-router-dom";
import SidebarAdmin from "../../menu/SidebarAdmin";
import Topbar from "../../menu/Topbar";
import CardsAdminUsuarios from "../../cards/CardsAdminUsuarios";
import BtnAcessoRapido from "../../AcessoRapido/BtnAcessoRapido";
import ListaUsuarios from "../ListaUsuarios/ListaUsuarios";
import Api from "../../Services/Api";

const Usuarios = () => {
  const navigate = useNavigate();

  const [menuClose, setMenuClose] = React.useState(false);
  const [usuarios, setUsuarios] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const toggleMenu = () => setMenuClose((prev) => !prev);

  React.useEffect(() => {
    const fetchUsuarios = async () => {
      try {
        setLoading(true);
        const res = await Api.get("/usuarios");
        setUsuarios(res.data);
      } catch (err) {
        console.error("Erro ao buscar usuários:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUsuarios();
  }, []);

  const handleEdit = (userId) => {
    navigate(`/adicionarusuarios/${userId}`);
  };

  const usuariosLicenciados = usuarios.filter(
    (u) => u.access_type?.toUpperCase() === "LICENSED"
  );

  const usuariosAtivos = usuariosLicenciados.filter(
    (u) => u.status?.toLowerCase() === "active"
  ).length;

  const usuariosInativos = usuariosLicenciados.filter(
    (u) => u.status?.toLowerCase() === "inactive"
  ).length;

  return (
    <div className="app-container">
      <SidebarAdmin close={menuClose} usuariosActive="active" />

      <main className="main-content">
        <Topbar page="Lista de Usuários / Licenciados" onToggleMenu={toggleMenu} />

        <CardsAdminUsuarios
          total={usuariosLicenciados.length}
          ativos={usuariosAtivos}
          inativos={usuariosInativos}
        />

        <BtnAcessoRapido
          icone="➕"
          text="Adicionar usuário / licenciado"
          link="/adicionarusuarios"
        />

        {loading ? (
          <p>Carregando usuários...</p>
        ) : (
          <ListaUsuarios lista={usuarios} onEdit={handleEdit} />
        )}
      </main>
    </div>
  );
};

export default Usuarios;
